import { useLottie } from 'lottie-react';
import React from 'react';
import styled from 'styled-components';

import animationData from '../animations/logo-spinner.json';

// Spinner - lottie animation of rotating Prosper logo

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
SpinnerWrapper.displayName = 'SpinnerWrapper';

export const Spinner = () => {
  const options = {
    animationData,
    loop: true,
    autoplay: true,
  };

  const style = {
    height: 60,
    width: 60,
  };

  const { View } = useLottie(options, style);

  return (
    <SpinnerWrapper
      id="animated-logo-spinner"
      data-testid="animated-logo-spinner"
      role="marquee"
      aria-label="loading"
    >
      {View}
    </SpinnerWrapper>
  );
};
